var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.286 0H1.714A1.714 1.714 0 0 0 0 1.714v12.572A1.714 1.714 0 0 0 1.714 16h4.9v-5.44H4.366V8h2.25V6.05a3.125 3.125 0 0 1 3.345-3.447 13.631 13.631 0 0 1 1.983.173V4.95h-1.117a1.28 1.28 0 0 0-1.443 1.387V8h2.456l-.393 2.56H9.384V16h4.9A1.714 1.714 0 0 0 16 14.286V1.714A1.714 1.714 0 0 0 14.286 0Z"
  })));
};

export default SvgFacebook;